import SeasonItem from "./SeasonItem";
import { useFetchSeasons } from "../../features/season/seasonApi";

const SeasonContent = () => {
    const {data:seasons} = useFetchSeasons()

    if(!seasons) {
        return(<></>)
    }

    return (
        <section className='py-2 slide-top'>
            <div className='container'>
                <div className="row justify-content-center py-4">
                    <div className="col-md-12">
                        <div className="row px-2 anim-delay-medium">
                            {seasons.data.map((season) => (
                                <SeasonItem key={season.id} season={season}/>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SeasonContent;
